import React from 'react'
import classNames from 'classnames'
import s from '../order-summary.scss'
import {getSummaryTicketPrice} from '../../../../selectors/placed-order'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {useDonationsAbcTranslation} from '../../../../hooks/donations-abc-translation'
import {TicketProps} from './index'

export const Ticket = ({ticket, t}: TicketProps) => {
  const quantity = ticket.orderedCount
  const {getFormattedMoney} = useCurrencyFormatter()
  const {translateDonations} = useDonationsAbcTranslation()
  const {labeledPrice, total} = getSummaryTicketPrice(ticket, t, getFormattedMoney, translateDonations)

  return (
    <div className={s.ticketInfo}>
      <div className={s.ticketName}>{ticket.name}</div>
      <div className={classNames(s.secondaryText, s.smallText, s.ticketPrice)}>{labeledPrice}</div>
      <div className={s.spreadRow}>
        <div className={classNames(s.secondaryText, s.smallText)}>{t('mobile.thanks.quantity', {quantity})}</div>
        <div>{total}</div>
      </div>
      <div className={s.divider} />
    </div>
  )
}
